import React, { useState } from 'react';

import RequestVerificationEmail from './RequestVerificationEmail';
import RequestVerificationEmailFail from './RequestVerificationEmailFail';
import RequestVerificationEmailSuccess from './RequestVerificationEmailSuccess';
import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  return new URLSearchParams(useLocation().search);
};

const RequestVerificationEmailContainer = () => {
  const [emailSent, setEmailSent] = useState<boolean>();
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const query = useQueryParams();
  const username = query.get('username');
  const requestOnly = query.get('request-only') === 'true';

  return (
    <div className="membership-content">
      {emailSent === true ? (
        <RequestVerificationEmailSuccess email={email} />
      ) : errorMessage || emailSent === false ? (
        <RequestVerificationEmailFail message={errorMessage} />
      ) : (
        <RequestVerificationEmail
          username={username}
          requestOnly={requestOnly}
          errorMessage={setErrorMessage}
          onEmailSent={(success, email) => {
            setEmailSent(success);
            setEmail(email);
          }}
        />
      )}
    </div>
  );
};

export default RequestVerificationEmailContainer;
